import { Server } from '../../clients/aasServerClient.generated';
import {
    ActionTypeNames,
    ClearSingleServerAction,
    CopySingleServerAction,
    CreateSingleServerAction,
    FetchAllServersAction,
    FetchSingleServerAction,
    FetchTableServersAction,
    FetchTableServersNFAction,
    NewSingleServerAction,
    SavedSingleServerAction,
    SaveSingleServerAction,
    ServersAction,
    StoreAllServersAction,
    StoreSingleServerAction,
    StoreTableServersAction,
} from './actions';

export function fetchTableServers(): FetchTableServersAction {
    return {
        type: ActionTypeNames.FetchTableServers
    };
}

export function fetchTableServersNF(): FetchTableServersNFAction {
    return {
        type: ActionTypeNames.FetchTableServersNF
    };
}


export function fetchAllServers(): FetchAllServersAction {
    return {
        type: ActionTypeNames.FetchAllServers
    };
}

export function fetchSingleServer(hostname: string): FetchSingleServerAction {
    return {
        hostname,
        type: ActionTypeNames.FetchSingleServer
    };
}
export function newSingleServer(): NewSingleServerAction {
    return {
        type: ActionTypeNames.NewSingleServer
    };
}

export function copySingleServer(hostname: string): CopySingleServerAction {
    return {
        hostname,
        type: ActionTypeNames.CopySingleServer
    };
}

export function storeSingleServer(server: Partial<Server>): StoreSingleServerAction {
    return {
        server,
        type: ActionTypeNames.StoreSingleServer,
    };
}

export function saveSingleServer(
    server: Partial<Server>,
): SaveSingleServerAction {
    return {
        server,
        type: ActionTypeNames.SaveSingleServer,
    };
}

export function createSingleServer(
    server: Partial<Server>,
): CreateSingleServerAction {
    return {
        server,
        type: ActionTypeNames.CreateSingleServer,
    };
}

export function clearSingleServer(): ClearSingleServerAction {
    return {
        type: ActionTypeNames.ClearSingleServer,
    };
}

export function savedSingleServer(): SavedSingleServerAction {
    return {
        type: ActionTypeNames.SavedSingleServer,
    };
}

function serversActionCreator<T extends ActionTypeNames>(type: T) {
    return (hostnames: string[]): ServersAction<T> => {
        return {
            serverHostnames: hostnames,
            type,
        };
    };
}

export function storeTableServers(servers: Server[]): StoreTableServersAction {
    return {
        servers,
        type: ActionTypeNames.StoreTableServers,
    };
}

export function storeAllServers(servers: Server[]): StoreAllServersAction {
    return {
        servers,
        type: ActionTypeNames.StoreAllServers,
    };
}

export const deleteServers = serversActionCreator(ActionTypeNames.DeleteServers);
export const generateNewKeys = serversActionCreator(ActionTypeNames.GenerateNewKeys);